import { render, staticRenderFns } from "./RevokeAccessTab.vue?vue&type=template&id=0ecda8e1&scoped=true"
import script from "./RevokeAccessTab.vue?vue&type=script&lang=js"
export * from "./RevokeAccessTab.vue?vue&type=script&lang=js"
import style0 from "./RevokeAccessTab.vue?vue&type=style&index=0&id=0ecda8e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecda8e1",
  null
  
)

export default component.exports